import { useEffect, useState } from 'react';
import styles from './FixcenterFooterBanner.module.scss';
import globalStyles from '../../global-styles.module.scss';
import newArrivals from '../../assets/img/FixcenterNewArrivals.png';
import askForAccess from '../../assets/img/FixcenterAskForAccess.png';
import supportMachines from '../../assets/img/FixcenterSupportMachines.png';
import webshop from '../../assets/img/FixcenterWebShop.png';
import { useTranslation } from '../../i18n/useTranslation';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT_PATHS, PRODUCT_SECOND_LEVEL_PATHS } from '../../shared/constants/breadcrumb.constants';
import { getCmsLinkToServices } from '../../containers/cms-container/services/cms-navigation.service';

export default function FixcenterFooterBanner() {
    const [bgImage, setBgImage] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [resetAnimation, setResetAnimation] = useState(false);
    const { t } = useTranslation('translation');
    const navigate = useNavigate();

    const init = () => {
        setResetAnimation(true);
        setIsActive(true);
        setBgImage(newArrivals);
        setTimeout(() => {
            setResetAnimation(false);
        }, 1200);
    };

    const setCurrentImage = (image: string): void => {
        if (image !== bgImage) {
            setBgImage('');
            setIsActive(false);
            setResetAnimation(false);
            setTimeout(() => {
                setResetAnimation(true);
                setIsActive(true);
                setBgImage(image);
            }, 500);
        }
    };

    const navigateTo = () => {
        switch (bgImage) {
            case newArrivals:
            case webshop:
                navigate(PRODUCT_SECOND_LEVEL_PATHS[1].link);
                break;
            case askForAccess:
                navigate(ACCOUNT_PATHS[0].link);
                break;
            case supportMachines:
                navigate(getCmsLinkToServices());
                break;
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <div
            className={`${styles.container} ${isActive ? styles.isActive : ''} ${resetAnimation ? styles.reset_animation : ''}`}
        >
            <div className={styles.left_side} style={{ backgroundImage: `url(${bgImage})` }}>
                {bgImage && (
                    <button
                        className={classNames(globalStyles.default_button_style, styles.more_detail_btn)}
                        onClick={() => navigateTo()}
                    >
                        <label className={globalStyles.float_left_item}>
                            <span className={globalStyles.mr_1}>{t('MORE')}</span>
                            <span>&#187;</span>
                        </label>
                    </button>
                )}
            </div>
            <div className={styles.right_side}>
                <div className={styles.text_wrapper}>
                    <div
                        className={`${styles.red_background} ${styles.margin_80}`}
                        onMouseEnter={() => setCurrentImage(newArrivals)}
                    >
                        {t('NEW_ARRIVALS')}
                    </div>
                    <div
                        className={`${styles.dark_background} ${styles.margin_60}`}
                        onMouseEnter={() => setCurrentImage(webshop)}
                    >
                        {t('WEB_SHOP')}
                    </div>
                    <div
                        className={`${styles.red_background} ${styles.margin_40}`}
                        onMouseEnter={() => setCurrentImage(askForAccess)}
                    >
                        {t('ASK_FOR_ACCESS')}
                    </div>
                    <div
                        className={`${styles.dark_background} ${styles.margin_bottom}`}
                        onMouseEnter={() => setCurrentImage(supportMachines)}
                    >
                        {t('WE_SUPPORT_YOUR_MACHINES_TOO')}
                    </div>
                </div>
            </div>
        </div>
    );
}
